var _g;
import { jsx as _jsx } from "react/jsx-runtime";
var LockCircle = function LockCircle(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _g || (_g = /*#__PURE__*/_jsx("g", {
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM9.4 9.5a2.6 2.6 0 1 1 5.2 0v1.592A2.001 2.001 0 0 1 16 13v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a2 2 0 0 1 1.4-1.908V9.5ZM12 8.1a1.4 1.4 0 0 0-1.4 1.4v1.4h2.8V9.5A1.4 1.4 0 0 0 12 8.1Z",
        fill: "none",
        className: "tw-fill-current"
      })
    }))
  });
};
export default LockCircle;